import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Scrolls so the element's top sits just below the sticky site header. */
export function scrollToBelowHeader(el: HTMLElement, extraGap = 16) {
  const header = document.querySelector("header");
  const headerH = header ? header.getBoundingClientRect().height : 0;
  const targetY = el.getBoundingClientRect().top + window.scrollY - headerH - extraGap;
  window.scrollTo({ top: Math.max(0, targetY), behavior: "smooth" });
}
